var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.container.cover ||
      _vm.container.doors ||
      _vm.container.flap
  )?_c('div',[_vm._v(" "+_vm._s(_vm.getContainerOpeningType(_vm.container))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }